<div>
     <section id="main"
              class="bg-light">
          <div id="monitoringContainer"
               class="container">
               <div class="overlay"
                    *ngIf="isLoading">
                    <h1 class="heading"
                        [innerHtml]="'Processing' | translator: 'base'">Loading...</h1>
                    <img alt="Loading" />
               </div>
               <div class="overlay"
                    *ngIf="isSaving">
                    <h1 class="heading"
                        [innerHtml]="'SavingLoaderText' | translator: 'base'">Saving...</h1>
                    <img alt="Saving" />
               </div>
               <h1 [innerHtml]="'pspMonitoringTitle' | translator: 'driver'">
                    PSP Monitoring Setting
               </h1>
               <div class="row">
                    <div class="col-12">
                         <div class="form-check mb-3"
                              [title]="'EnrollInMonitoring' | translator: 'driver'"
                         >
                              <label class="form-check-label">
                                   <input type="checkbox"
                                          true-value="true"
                                          false-value="false"
                                          name="enrollCheck"
                                          id="enrollCheck"
                                          [(ngModel)]="isEnrolled"
                                          class="form-check-input" /> 
                                   <span [innerHtml]="'EnrollInMonitoring' | translator: 'driver'">&nbsp;
                                        Enroll in PSP Monitoring
                                   </span>
                              </label>
                         </div>
                    </div>
                    <div class="col-12">
                         <p [innerHtml]="'enrollGetEmail' | translator: 'driver'" 
                            *ngIf="isEnrolled">
                              The next time your PSP record changes you will receive an email notification.
                         </p>
                         <p [innerHtml]="'enrollGetNoEmail' | translator: 'driver'"
                            *ngIf="!isEnrolled">
                              You will not receive an email when your PSP record changes.
                         </p>
                    </div>
                    <div class="col-12">
                         <button class="btn btn-primary mb-3 me-2"
                                 (click)="save()"
                                 [title]="'Save' | translator: 'base'"
                                 id="save"
                                 name="save" 
                                 [innerHtml]="'Save' | translator: 'base'">
                                   Save
                         </button>
                         <button [routerLink]="'/driverDashboard'"
                                 class="btn btn-light mb-3"
                                 [title]="'Cancel' | translator: 'base'"
                                 id="cancel"
                                 name="cancel"
                                 [innerHtml]="'Cancel' | translator: 'base'">
                                   Cancel
                         </button>
                    </div>
                    <ng-template #ErrorSavingModal let-modal>
                         <div class="modal-header">
                              <h3 
                                   id="errorSavingModalTitle" 
                                   class="modal-title"
                                   [innerHtml]="'Problem' | translator: 'driver'"
                              >
                                   A problem has occurred
                              </h3>
                         </div>
                         <div class="modal-body">
                              <p [innerHtml]="'WasError' | translator: 'driver'">
                                   Please contact the PSP Customer Support Team at
                                   <a alt="call customer service" href="tel:8776429499" name="1-877-642-9499">1-877-642-9499</a>.
                                   The PSP team is available by phone Monday through Thursday from 8 AM to 6
                                   PM ET, and on Friday from 8 AM to 5 PM ET.
                              </p>
                         </div>
                         <div class="modal-footer">
                              <button class="btn btn-primary"
                                      [title]="'OK' | translator: 'base'"
                                      [innerHtml]="'OK' | translator: 'base'"
                                      name="okay"
                                      (click)="closeModal()"
                              >OK
                              </button>
                         </div>
                    </ng-template>
               </div>
          </div>
     </section>
</div>